const UnderConstruction = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column", // For vertical stacking; change to "row" if you want a horizontal layout.
        justifyContent: "center", // Vertically centers items.
        alignItems: "flex-end", // Aligns items horizontally to the right.
        minHeight: "90vh", // Ensures full viewport height.
        backgroundPosition: "center",
        backgroundSize: "cover",
        width: "100%",
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/under_construction.jpg)`,
      }}
    />
  );
};

export default UnderConstruction;

// import React, { useState, useRef } from "react";

// const ComPortReader = () => {
//   const [selectedPort, setSelectedPort] = useState(null);
//   const [receivedData, setReceivedData] = useState("");
//   const readerRef = useRef(null);

//   const connectPort = async () => {
//     try {
//       // Ask user to select COM port
//       const port = await navigator.serial.requestPort();
//       await port.open({ baudRate: 9600 });

//       setSelectedPort(port);

//       const textDecoder = new TextDecoderStream();
//       port.readable.pipeTo(textDecoder.writable);
//       const reader = textDecoder.readable.getReader();
//       readerRef.current = reader;

//       // Start reading data
//       while (true) {
//         const { value, done } = await reader.read();
//         if (done) break;
//         if (value) {
//           setReceivedData(value.trim());
//         }
//       }
//     } catch (err) {
//       console.error("COM Port error:", err);
//     }
//   };

//   const disconnectPort = async () => {
//     try {
//       if (readerRef.current) {
//         await readerRef.current.cancel();
//         readerRef.current = null;
//       }
//       if (selectedPort) {
//         await selectedPort.close();
//         setSelectedPort(null);
//       }
//     } catch (err) {
//       console.error("Disconnect error:", err);
//     }
//   };

//   return (
//     <div style={{ display: "flex", gap: "20px", padding: "20px" }}>
//       {/* Left side */}
//       <div>
//         <h4>COM Port</h4>
//         <button onClick={connectPort}>Select COM Port</button>
//         <br />
//         <br />
//         <button onClick={disconnectPort} disabled={!selectedPort}>
//           Disconnect
//         </button>
//       </div>

//       {/* Right side */}
//       <div>
//         <h4>Received Data</h4>
//         <input
//           type="text"
//           value={receivedData}
//           readOnly
//           style={{ width: "250px" }}
//         />
//       </div>
//     </div>
//   );
// };

// export default ComPortReader;
